import axios from 'axios';
import clientConfig from '../client-config';
import setAuthToken from '../utils/setAuthToken';

export async function startBarionPayment(paymentData) {
  // Send request
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  if (localStorage.token) {
    let res;
    try {
      res = await axios.post(
        clientConfig.backendHOST + '/barion/StartPayment',
        paymentData,
        config
      );
    } catch (e) {
      console.error('error', e);
      return {
        isOk: false,
        error: e,
      };
    }

    if (res) {
      if (res.status === 200) {
        return {
          isOk: true,
          data: res,
        };
      }
    } else {
      return {
        isOk: false,
      };
    }
  } else {
    return {
      isOk: false,
    };
  }
}
